import { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import api from "@/lib/api";

const FIELDS = [
  { k: "company_name", l: "Nome da empresa" },
  { k: "tagline", l: "Assinatura / Tagline" },
  { k: "whatsapp", l: "WhatsApp (só números, ex.: 5547999999999)" },
  { k: "phone", l: "Telefone exibido" },
  { k: "email", l: "E-mail de contato" },
  { k: "address", l: "Endereço" },
  { k: "cnpj", l: "CNPJ" },
  { k: "logo", l: "Logo (URL)" },
];
const ANALYTICS = [
  { k: "ga_id", l: "Google Analytics ID (G-XXXX)" },
  { k: "gtm_id", l: "Google Tag Manager ID (GTM-XXXX)" },
  { k: "meta_pixel_id", l: "Meta Pixel ID" },
  { k: "gsc_verification", l: "Google Search Console (código de verificação)" },
];

export default function ConfigAdmin() {
  const [cfg, setCfg] = useState(null);

  useEffect(() => { api.get("/config").then((r) => setCfg(r.data || {})); }, []);
  const set = (k, v) => setCfg((c) => ({ ...c, [k]: v }));

  const save = async () => {
    const payload = { ...cfg }; delete payload._id;
    try {
      await api.put("/admin/config", payload);
      toast.success("Configurações salvas");
    } catch {
      toast.error("Erro ao salvar configurações");
    }
  };

  if (!cfg) return <p className="text-[#A1A1AA]">Carregando...</p>;

  return (
    <div className="max-w-2xl">
      <h1 className="font-heading text-2xl font-bold text-white">Configurações</h1>
      <p className="mt-1 text-sm text-[#A1A1AA]">Dados da empresa, WhatsApp e IDs de rastreamento (Analytics, GTM, Meta Pixel).</p>

      <div className="mt-6 space-y-4 border border-[#27272A] bg-[#151618] p-6">
        <h3 className="font-heading font-bold text-white">Empresa & Contato</h3>
        {FIELDS.map((f) => (
          <div key={f.k}><Label className="label-eyebrow">{f.l}</Label>
            <Input data-testid={`config-${f.k}`} value={cfg[f.k] || ""} onChange={(e) => set(f.k, e.target.value)} className="mt-1 rounded-none border-[#27272A] bg-[#0A0A0B]" /></div>
        ))}
      </div>

      <div className="mt-4 space-y-4 border border-[#27272A] bg-[#151618] p-6">
        <h3 className="font-heading font-bold text-white">Analytics & Rastreamento</h3>
        <p className="text-xs text-[#71717A]">Cole aqui os IDs quando tiver as contas. Os scripts são injetados automaticamente no site.</p>
        {ANALYTICS.map((f) => (
          <div key={f.k}><Label className="label-eyebrow">{f.l}</Label>
            <Input data-testid={`config-${f.k}`} value={cfg[f.k] || ""} onChange={(e) => set(f.k, e.target.value)} className="mt-1 rounded-none border-[#27272A] bg-[#0A0A0B]" /></div>
        ))}
      </div>

      <Button data-testid="config-save" onClick={save} className="mt-6 rounded-none bg-[#FF5500] px-8 font-bold hover:bg-[#CC4400]">Salvar configurações</Button>
    </div>
  );
}
